module.exports = __webpack_public_path__ + "static/15-827f0053eeddbe65d63d1b58385d6af3.png";